import { css, SerializedStyles } from '@emotion/react'
import { Color, Spacing, Typeface, Typography } from '@opallabs/gem'

export const approvalItem = (recentlyCompleted: boolean): SerializedStyles =>
  css({
    backgroundColor: Color.light.Surface.N000,
    alignItems: 'flex-start',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '12px',
    fontFamily: Typeface.Monospace,
    flexDirection: 'column',
    paddingBlock: Spacing.S,
    paddingInline: Spacing.S * 1.25,
    opacity: recentlyCompleted ? 0.35 : '',

    '> *': {
      opacity: recentlyCompleted ? 0.35 : '',
    },
    '&:hover': {
      backgroundColor: Color.light.Translucent.A08,
    },
  })

export const approvalItemRow = css({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  fontWeight: 'normal',
  padding: '0',
  transition: 'opacity .15s ease-out',
  inlineSize: '100%',
})

export const approvalContext = css({
  display: 'flex',
  marginBlockStart: 1,

  '.kuiper-icon-wrapper': {
    marginInlineEnd: Spacing.S * 1.25,
  },
})

export const approvalText = css({
  maxInlineSize: Spacing.M * 10.625,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  paddingBlockEnd: Spacing.XS / 2,
})

export const approvalContextText = css({
  ...Typography.T300,
})

export const approvalDetail = css({
  display: 'flex',
  flex: '1 1 auto',
})

export const approvalDetailText = css(
  {
    color: Color.light.Text.Default,
    marginInlineEnd: Spacing.XS * 1.25,
  },
  approvalText
)
